import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import Cookies from 'universal-cookie';
const cookies = new Cookies();









export const errorHelper = (formik,values) => ({
    error: formik.errors[values] && formik.touched[values] ? true :false,
    helperText: formik.errors[values] && formik.touched[values] ? formik.errors[values]:null
})

export const Loader = () => (
    <div className='root_loader'>
        <CircularProgress/>
    </div>
)

export const showToast = (type,msg) => {
    switch(type){
        case 'SUCCESS':
            toast.success(msg,{
                position: toast.POSITION.BOTTOM_RIGHT
            })
        break;
        case 'ERROR':
            toast.error(msg,{
                position: toast.POSITION.BOTTOM_RIGHT
            })
        break;
        default:
            return false

    }
}



export const getTokenCookie = () => cookie.load('accessTokenMNS');
export const getUserData = () => cookie.load('userSMNS');
export const removeTokenCookie = () => cookie.remove('accessTokenMNS',{path:'/'});




export const removeUserData = () => cookie.remove('userSMNS');

//console.log(cookies.get('myCat')); //
//export const setTokenCookie = (values) => cookies.set('accessToken', values, { path: '/' });
export const setTokenCookie = (values) => cookies.set('accessTokenMNS', values);
export const setUserData = (values) => cookies.set('userSMNS', values);
export const getAuthHeader = () => {
    return { headers:{'Content-Type': 'application/json','Authorization':`Bearer ${getTokenCookie()}`}}
}

export const getAuthHeaderforimage = () => {
    return { headers:{'Authorization':`Bearer ${getTokenCookie()}`,"Content-Type": "multipart/form-data",
    "x-rapidapi-host": "file-upload8.p.rapidapi.com",
    "x-rapidapi-key": "your-rapidapi-key-here",}
}
}
export const htmlDecode = (input) => {
    const doc = new DOMParser().parseFromString(input,"text/html")
    return doc.documentElement.textContent;
}




